module.exports = __webpack_public_path__ + "img/psm_logo-inverse.3dce9c2a.png";